import { title } from "process";
import { InfoBox } from "../../../../ui/molecules/infoBox";
import { FileInputComponent } from "../../../../ui/molecules/fileInput";
import Button from "../../../../ui/molecules/button";
import { DocumentIcon } from "../../../../ui/icons/documentIcon";
import { SaveIcon } from "../../../../ui/icons/SaveIcon";
import { PopupForm } from "../../../../ui/organisms/popupForm";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { GetInspectionVisitById, InspectionVisitUploadFile, resetGetInspectionVisitByIdStatus, resetInspectionVisitUploadFileStatus, setIVFileToUpload, setIVUploadedFileId } from "../../slice";
import { FileViewer } from "../../../../ui/molecules/fileViewer";
import { TrashIcon } from "../../../../ui/icons/trash";
import { GetFileById, resetGetFileByIdStatus } from "../../../../objectStorage/slice";
import { GetFileByIdDTO } from "../../../../objectStorage/dataService/dto";

export function InspectionVisitEditRight() {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const userState = useAppSelector(state => state.users)
    const objectStorageState = useAppSelector(state => state.objectStorage)
    const [showLoadPopup, setShowLoadPopup] = useState<boolean>(false)
    const [fileToShow, setFileToShow] = useState<GetFileByIdDTO | null>(null)

    let formData = new FormData()

    const handleOnLoad = () => {
        formData.delete('file')
        formData.delete('officerId')
        formData.append('file', assignmentState.ivFileToUpload!)
        formData.append('officerId', JSON.stringify(userState.findMeResponse.id))
        dispatch(InspectionVisitUploadFile({
            data: formData,
            id: assignmentState.inspectionVisitIdToUpdate
        }))
    }

    useEffect(() => {
        if(assignmentState.ivUploadedFileId) {
            dispatch(GetFileById(assignmentState.ivUploadedFileId))
        }
    }, [assignmentState.ivUploadedFileId])

    useEffect(() => {
        if(objectStorageState.getFileByIdStatus === 'successfully' &&
            objectStorageState.getFileByIdResponse !== undefined
        ) {
            dispatch(resetGetFileByIdStatus())
            setFileToShow(objectStorageState.getFileByIdResponse)
        }
    }, [objectStorageState.getFileByIdStatus])

    useEffect(() => {
        if(assignmentState.inspectionVisitUploadFileStatus === 'successfully' &&
            assignmentState.inspectionVisitUploadFileResponse !== undefined
        ) {
            dispatch(resetInspectionVisitUploadFileStatus())
            dispatch(GetInspectionVisitById(assignmentState.inspectionVisitIdToUpdate))
        }
    }, [assignmentState.inspectionVisitUploadFileStatus])

    useEffect(() => {
        if(assignmentState.getInspectionVisitByIdStatus === 'successfully' && 
            assignmentState.getInspectionVisitByIdResponse !== undefined
        ) {
            dispatch(resetGetInspectionVisitByIdStatus())
            dispatch(setIVUploadedFileId(assignmentState.getInspectionVisitByIdResponse.fileId))
        }
    }, [assignmentState.getInspectionVisitByIdStatus])

    return (
        <div style={{ padding: '24px' }}>
            <div className="text-left pb-5">
                <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Info Operatore</span>
            </div>

            <div className="pb-5">
                <InfoBox
                    color="green"
                    content={[
                        {
                            title: 'Ragione Sociale',
                            label: 'MADFARM SRL'
                        },
                        {
                            title: 'CUAA',
                            label: '123456789010'
                        },
                    ]}
                />
            </div>

            <div className="text-left pb-20">
                <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Valutazione Controllo</span>
            </div>

            <div className="text-left pb-20">
                <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Valutazione Ispettore</span>
            </div>

            <div className="text-left pb-5">
                <span className='assignment-title-bold' style={{ color: '#314d51' }}>Visite Ispettive </span>
                <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Upload PDF del Controllo</span>
            </div>

            <Button
                variant="solid"
                color="dimgrey"
                size="md"
                iconPosition="left"
                icon={<SaveIcon />}
                label="Carica file"
                onClick={() => setShowLoadPopup(true)}
            />

            {
                showLoadPopup && (
                    <PopupForm headerGreen={true} title="Upload File Visita Ispettiva" close={() => {
                        setShowLoadPopup(false)
                    }}>
                        <div className="p-[24px]">
                            <div className="text-left pb-3">
                                <span className="assignment-subtitle">Seleziona e invia incarico firmato</span>
                            </div>
                            <div className="pb-3">
                                <FileInputComponent
                                    id={"ep-edit-upload-add"}
                                    key={"ep-edit-upload-add"}
                                    infoText
                                    fullHeight
                                    color={"green"}
                                    onChange={(e) => {
                                        dispatch(setIVFileToUpload(e[0]))
                                    }}
                                />
                                {
                                    assignmentState.ivFileToUpload && (
                                        <div className="pt-3" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                            <FileViewer
                                                toUpdate
                                                fileName={assignmentState.ivFileToUpload.name}
                                                otherInfo={assignmentState.ivFileToUpload.type}
                                            />
                                            <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => dispatch(setIVFileToUpload(null))}>
                                                <TrashIcon size={20} color="dimgrey" />
                                            </button>
                                        </div>
                                    )
                                }
                                {
                                    (assignmentState.ivUploadedFileId && fileToShow) && (
                                        <div className="pt-3" style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                            <FileViewer
                                                fileId={assignmentState.ivUploadedFileId}
                                                fileName={fileToShow.name}
                                                otherInfo={fileToShow.data}
                                            />
                                            {/* <button style={{ display: 'flex', justifyContent: 'center' }} onClick={() => setFileToShow(null)}>
                                                <TrashIcon size={20} color="dimgrey" />
                                            </button> */}
                                        </div>
                                    )
                                }

                            </div>
                            <div className="flex align-right" >
                                <Button
                                    disabled={assignmentState.ivFileToUpload === null}
                                    size={"sm"}
                                    iconPosition={"off"}
                                    variant={"solid"}
                                    label="Carica File"
                                    color={"green"}
                                    onClick={() => handleOnLoad()}
                                />
                            </div>
                        </div>
                    </PopupForm>
                )
            }
        </div>
    )
}